import { DISPLAY_TRACKING_USER_HISTORY, UPDATE_TRACKING_USER_HISTORY } from '../../../types/conversations/plugins'
import apiConversation from 'api/conversation'

/**
 * Display tracking history container
 * @param {String} userId
 * @param {Boolean} isOpen
 * @param {Boolean} [isLoading=false]
 */
const displayTrackingHistory = (userId, isOpen, isLoading = false) => {
  return {
    type: DISPLAY_TRACKING_USER_HISTORY,
    isOpen,
    userId,
    isLoading,
  }
}

/**
 * Update user tracking history
 * @param {String} userId
 * @param {Array} [history=[]]
 */
const updateTrackingHistory = (userId, history = []) => {
  return {
    type: UPDATE_TRACKING_USER_HISTORY,
    userId,
    history,
  }
}

/**
 * Close collapse for user history plugin
 */
const close = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  dispatch(displayTrackingHistory(activeUser, false))
}

/**
 * Open collapse for user history plugin
 */
const open = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs

  dispatch(displayTrackingHistory(activeUser, true))
}


/**
 * Get user tracking history
 */
const get = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  const { conversations } = getStore()
  const currentConversation = conversations[activeUser]
  const conversationId = currentConversation?.user?._id

  if (!conversationId) return

  dispatch(displayTrackingHistory(activeUser, true, true))

  try {
    const { data } = await apiConversation.plugins.trackingUserHistory({ conversationId, page: 0, limit: 100 })

    dispatch(updateTrackingHistory(activeUser, data ? data?.history || [] : []))
  } catch (error) {
    console.error('error: ', error)
  }
}

const addTrackingEvent = (userId, trackingEvents) => async (dispatch, getStore) => {
  if (!trackingEvents) return

  const { activeUser } = getStore().tabs
  const { conversations } = getStore()
  const currentConversation = conversations[activeUser]
  const conversationId = currentConversation?.user?._id

  if (!conversationId) return
  if (conversationId !== userId) return

  const { plugins: { trackingUserHistory: { history } } } = currentConversation

  dispatch(updateTrackingHistory(activeUser, [trackingEvents, ...history]))
}


export default {
  close,
  open,
  get,
  addTrackingEvent,
}
